// extracted by mini-css-extract-plugin
module.exports = {"speedTabText":"SpeedTabText_speedTabText_3-7E1","icon":"SpeedTabText_icon_1UR2Q","text":"SpeedTabText_text_2OTjT"};